



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule, { UserModel } from '@/stores/StoreVuexModule';
import Axios from 'axios';
import Shared from '@/common/shared';

interface StoreModel {
  id: number;
  name: string;
}

interface DeviceModel {
  id: number;
  name: string;
}

interface LoginRequestModel {
  retailerId: number;
  storeId: number;
  deviceId: number;
  password: string;
}

@Component({
  name: 'LoginDialog',
})
export default class LoginDialog extends Vue {
  private loading: boolean = false;
  private valid: boolean = true;
  private submitting: boolean = false;
  private error: string = '';
  private stores: StoreModel[] = [];
  private devices: DeviceModel[] = [];
  private vuexStore = getModule(StoreVuexModule, this.$store);

  private selectedStoreId: number | null = null;
  private selectedDeviceId: number | null = null;
  private password: string = '';
  private selectRules: any = [(v: any) => !!v || 'please select a value'];
  private passwordRules: any = [(v: any) => !!v || 'password is required'];

  private async mounted() {
    if (this.stores.length === 0) {
      this.loading = true;
      this.stores = (await Axios.get<StoreModel[]>(
        this.vuexStore.baseApiUrl +
          'Retailer/ListStores?retailerId=' +
          this.vuexStore.currentConfig.retailerId,
      )).data;

      if (this.stores.length > 0) {
        let sid = this.stores[0].id;
        if (localStorage && localStorage.getItem) {
          const lsid = parseInt(
            localStorage.getItem(Shared.localStorageKeys.LOGIN_STORE_ID) || 'X',
            10,
          );
          if (lsid && this.stores.filter((e) => e.id === lsid).length === 1) {
            sid = lsid;
          }
        }
        this.selectedStoreId = sid;
      } else {
        this.loading = false;
      }
    }
  }

  private get showDialog(): boolean {
    return !this.vuexStore.hasRequiredUserRole;
  }

  private get passwordLabel(): string {
    let res = 'Enter ';
    switch (this.vuexStore.requiredUserRole) {
      case 'OrderPoint':
        res += 'Order Point';
        break;
      default:
        res += this.vuexStore.requiredUserRole || '';
    }
    return res + ' Password';
  }

  private get loginForm(): any {
    return this.$refs.loginForm as any;
  }

  @Watch('showDialog')
  private onShowDialogChanging(isShowing: boolean) {
    // if we have access to localStorage
    if (localStorage && localStorage.setItem && localStorage.getItem) {
      if (isShowing) {
        // grab saved values from storage on show
        this.selectedDeviceId =
          parseInt(
            localStorage.getItem(Shared.localStorageKeys.LOGIN_DEVICE_ID) ||
              'X',
            10,
          ) || null;
        this.selectedStoreId =
          parseInt(
            localStorage.getItem(Shared.localStorageKeys.LOGIN_STORE_ID) || 'X',
            10,
          ) || null;
        this.password = '';
        this.loginForm.resetValidation();
        this.error = '';
      } else {
        // save selected values to storage on hide
        if (this.selectedDeviceId) {
          localStorage.setItem(
            Shared.localStorageKeys.LOGIN_DEVICE_ID,
            this.selectedDeviceId.toString(),
          );
        }
        if (this.selectedStoreId) {
          localStorage.setItem(
            Shared.localStorageKeys.LOGIN_STORE_ID,
            this.selectedStoreId.toString(),
          );
        }
        this.loginForm.reset();
        this.error = '';
      }
    }
  }

  @Watch('selectedStoreId')
  private async onSelectedStoreIdChanged() {
    if (this.selectedStoreId) {
      // have an id, select devices
      this.loading = true;
      this.selectedDeviceId = null;
      this.devices = (await Axios.get<DeviceModel[]>(
        this.vuexStore.baseApiUrl +
          'Retailer/ListDevices?storeId=' +
          this.selectedStoreId,
      )).data;

      if (localStorage && localStorage.getItem) {
        const ldid = parseInt(
          localStorage.getItem(Shared.localStorageKeys.LOGIN_DEVICE_ID) || 'X',
          10,
        );
        if (this.devices.filter((e) => e.id === ldid).length === 1) {
          this.selectedDeviceId = ldid;
        }
      }
    }
    this.loading = false;
  }

  @Watch('selectedDeviceId')
  @Watch('selectedStoreId')
  @Watch('password')
  private clearError() {
    this.error = '';
  }

  private async loginFormSubmit(e: Event) {
    e.preventDefault();
    if (
      !this.loginForm.validate() ||
      !this.selectedStoreId ||
      !this.selectedDeviceId
    ) {
      // validation errors, exit now
      return;
    }
    const req: LoginRequestModel = {
      retailerId: this.vuexStore.currentConfig.retailerId,
      storeId: this.selectedStoreId,
      deviceId: this.selectedDeviceId,
      password: this.password,
    };

    const r = this.vuexStore.requiredUserRole;
    if (r) {
      this.submitting = true;
      const res = await Axios.post<string>(
        this.vuexStore.baseApiUrl + `Auth/${r}Login`,
        req,
        {
          validateStatus: (c) => true,
        },
      );
      switch (res.status) {
        case 200:
          try {
            this.vuexStore.updateUserModel(res.data);
            this.error = '';
          } catch (err) {
            this.error =
              'failed to parse user. please try again or contact support for assistance';
          }
          break;
        case 401:
          this.error = 'invalid credentials, please try again';
          break;
        default:
          this.error = `unexpected result from login: (${
            res.status
          }). please try again or contact support for assistance`;
      }
      this.submitting = false;
    }
  }
}
